import { motion, useReducedMotion } from "framer-motion";

/** The KSKF short mark turning slowly inside a ring — a fixed point while the page moves. */
export const SpinningMark = ({ size = 132, className = "", testId = "spinning-mark" }) => {
  const still = useReducedMotion();

  return (
    <div
      className={`relative shrink-0 ${className}`}
      style={{ width: size, height: size }}
      data-testid={testId}
      aria-hidden="true"
    >
      <motion.div
        className="absolute inset-0 rounded-full border border-white/15"
        animate={still ? {} : { rotate: 360 }}
        transition={{ duration: 16, repeat: Infinity, ease: "linear" }}
      >
        <span className="absolute left-1/2 top-0 h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-maasai" />
        <span className="absolute left-1/2 bottom-0 h-1 w-1 -translate-x-1/2 translate-y-1/2 rounded-full bg-ochre" />
      </motion.div>
      <motion.div
        className="absolute inset-[10%] rounded-full border border-dashed border-white/10"
        animate={still ? {} : { rotate: -360 }}
        transition={{ duration: 26, repeat: Infinity, ease: "linear" }}
      />
      <motion.img
        src="/brand/kskf-short-white.png"
        alt=""
        className="absolute left-1/2 top-1/2 w-[62%] -translate-x-1/2 -translate-y-1/2 object-contain"
      />
    </div>
  );
};
